import { render } from "./Receivers.vue?vue&type=template&id=560ac39d&scoped=true&ts=true"
import script from "./Receivers.vue?vue&type=script&lang=ts"
export * from "./Receivers.vue?vue&type=script&lang=ts"

import "./Receivers.vue?vue&type=style&index=0&id=560ac39d&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-560ac39d"]])

export default __exports__